import ChannelsCenterFeatureIcon from "@/components/ui/OpticksIcons/ChannelsCenterFeatureIcon";
import OpticksLink from "@/components/ui/OpticksLink/OpticksLink";
import OpticksNumberCircle from "@/components/ui/OpticksNumberCircle/OpticksNumberCircle";
import { routesMap } from "@/components/routes/routes";

interface Props {
  stepLabel?: string;
}

const RedditIntegrationStep1 = ({ stepLabel }: Props) => (
  <div className="channels-integration-step reddit-step-1">
    <div className="step-label-row">
      {stepLabel && <OpticksNumberCircle number={stepLabel} />}
      <h6>Reddit Pixel installation</h6>
    </div>
    <div className="wrapper">
      <p>
        The{" "}
        <OpticksLink
          href="https://ads.reddit.com"
          label="Reddit Pixel"
        />{" "}
        is the piece of code that allows Reddit to track conversions and build
        Audiences. It is required for the audience exclusion feature to work.
      </p>
      <p>
        Opticks uses these Audiences to exclude invalid traffic from your
        campaigns. The first step is to make sure that both the{" "}
        <b>Opticks script</b> and your <b>Reddit Pixel</b> are properly
        installed on the same page you want to protect.
      </p>
      <p>
        Opticks will automatically send exclusion events for invalid visits to
        the detected Reddit Ads pixels, or you can manually decide which ones to
        use in our{" "}
        <OpticksLink
          to={`${routesMap.integration.channelsCenter.path}?channel=reddit`}
          label="Channels Center"
          icon={<ChannelsCenterFeatureIcon />}
        />
        .
      </p>
    </div>
  </div>
);

export default RedditIntegrationStep1;
